<template>
  <router-view/>
</template>

<style lang="stylus">
</style>
